import script from "./HeroSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroSettings.vue?vue&type=script&setup=true&lang=js"

import "./HeroSettings.vue?vue&type=style&index=0&id=fc80a96c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc80a96c"]])

export default __exports__